import { Injectable } from '@angular/core';
import { HttpRequestService } from '../../shared/services/http-request.service';
import { Globals } from '../../shared/services/globals';
import { TranslateService } from '@ngx-translate/core';
import { UserData } from '../../shared/models/DTO/UserData';
import { GenericVm } from '../../shared/models/system/generic-vm';
import { Message } from '../../shared/models/system/message';
import { MessageEnum } from '../../shared/models/system/message.enum';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpRes: HttpRequestService, private globals: Globals, private translate: TranslateService) { }

  getUsers(page, pageSize) {
    return this.httpRes.GetRequest('user/getusers/' + page + '/' + pageSize);
   
  }

  searchUsers(keyWord,role,page, pageSize) {
    var url = 'user/Search/' + encodeURIComponent(keyWord);

    return this.httpRes.GetRequest(url+'/' + role +'/' + page + '/' + pageSize);

  }
  listRoles(){
    return this.httpRes.GetRequest('role/all');
  }


  
}
